import { createFileRoute, redirect } from "@tanstack/react-router";

// Compatibility for bookmarks and older notification links; no Providers page.
export const Route = createFileRoute("/settings/providers")({
  beforeLoad: () => {
    throw redirect({ to: "/settings/subscription-accounts", replace: true });
  },
});
